import React from "react";
import "./sidenavbar.scss";
import { AiOutlineForm } from "@react-icons/all-files/ai/AiOutlineForm";
import { FaWpforms } from "@react-icons/all-files/fa/FaWpforms";
import { AiOutlinePartition } from "@react-icons/all-files/ai/AiOutlinePartition";
import { HiOutlineCheckCircle } from "@react-icons/all-files/hi/HiOutlineCheckCircle";
import { FiLogOut } from "@react-icons/all-files/fi/FiLogOut";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { StorageHelpers } from "../../core/Helpers";
import { useDispatch, useSelector } from "react-redux";
import { setToken, setUserToken } from "../../redux/slices/authSlice";
import { setClinicName } from "../../redux/slices/clinicSlice";
import { HomeOutlined } from "@ant-design/icons";
import {
  clearGroup,
  setAllDataSelected,
  setCurrentStep,
  setSelectedUser,
  setSelectItem,
} from "../../redux/slices/searchSlice";
import { emptyDescription } from "../../redux/slices/fileUploadSlice";
import { setIsEdit } from "../../redux/slices/PageSlice";

const SideNavbar = () => {
  const clinicName = useSelector((state) => state.clinicSlice.clinicName);
  const token = useSelector((state) => state.authSlice.token);
  const dispatch = useDispatch();
  const logoutHandle = () => {
    StorageHelpers.removeAuthToken();
    StorageHelpers.removeUserAuthToken();
    dispatch(setToken(null));
    dispatch(setUserToken(null));
    dispatch(setClinicName(""));
  };
  const navigate = useNavigate();
  const onClickHandle = () => {
    dispatch(setIsEdit(false));
    dispatch(setCurrentStep(1));
    dispatch(setSelectItem(null));
    dispatch(setSelectedUser(null));
    dispatch(emptyDescription());
    dispatch(clearGroup());
    dispatch(setAllDataSelected({}));
    navigate("/select-patient/request-form");
  };

  return (
    <div className="sidenavbar-container shadow-lg  bg-white w-80 lg:w-60 xl:w-80  fixed   p-4 h-screen   text-3xl">
      <div className="mt-4   w-fit   h-full flex justify-between   flex-col">
        <div className="">
          {" "}
          <Link
            className="text-current hover:text-current "
            to={`${token !== null ? "/request-list" : "/user-home"}`}
          >
            <img src="/assets/images/logo.png" alt="Logo" />
          </Link>
          <div className="user-info items-center justify-center flex ">
            <div className=" mt-4 flex text-sm gap-2 flex-col items-center text-center ">
              <div className="flex flex-col">
                <span className="font-base font-semibold text-xl text-gray-400">
                  {clinicName}
                </span>
              </div>
            </div>
          </div>
          {token !== null ? (
            <ul className="sideMenu h-full">
              <NavLink
                className="text-current hover:text-current"
                to="./request-list"
              >
                <li className="p-3">
                  <FaWpforms /> Taleplerim
                </li>
              </NavLink>
              <NavLink
                onClick={onClickHandle}
                className=""
                to="./select-patient"
              >
                <li className="p-3">
                  <AiOutlineForm /> Ön Talep Formu
                </li>
              </NavLink>
              <NavLink
                className="text-current hover:text-current"
                to="./patients"
              >
                <li className="p-3">
                  <AiOutlinePartition />
                  Hastalarım
                </li>
              </NavLink>
            </ul>
          ) : (
            <ul className="sideMenu h-full">
              <NavLink to="./user-home">
                <li className="p-3 user-nav">
                  <HomeOutlined /> Anasayfa
                </li>
              </NavLink>
              <NavLink to="./user-appointments">
                <li className="p-3 user-nav">
                  <AiOutlineForm /> Randevularım
                </li>
              </NavLink>
              <NavLink to="./user-results">
                <li className="p-3 user-nav">
                  <HiOutlineCheckCircle /> Sonuçlarım
                </li>
              </NavLink>
            </ul>
          )}
        </div>

        <div
          onClick={logoutHandle}
          className="font-semibold mb-5 hover:bg-red-100 rounded-xl cursor-pointer hover:text-red-500 duration-300 tracking-wider gap-1 text-sm p-4 flex text-gray-400 drop-shadow-xs items-center "
        >
          <FiLogOut className="text-base" />
          Çıkış yap
        </div>
      </div>
    </div>
  );
};

export default SideNavbar;
